module.exports = __webpack_public_path__ + "static/media/kematian.27ecf10a.png";